"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f55300 = void 0;
exports.f55300 = {
    "𑄌𑄋𑄴𑄟𑄳𑄦": [
        1381,
        1383
    ]
};
